import React, { useEffect, useState } from "react";
import DashTable from "../ProcedureTemplates/DashTable";
import DashTabs from "./DashTabs";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import AddProcedure from "./ProcedureDetails";
import { useGetProcedureTemplatesQuery } from "../../../../Service/Masters";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";
import { useDispatch } from "react-redux";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import Loader from "../../../../Component/DigitalMarketing/Loader";

const ProcedureTemplates = () => {
  const [updateData, setUpdateData] = useState<any>([]);
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [pagination, setpagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const { data: procedureData, refetch,isLoading } = useGetProcedureTemplatesQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setpagination(1);
    refetch();
  }, [searchValue]);

  useEffect(() => {
    const data: any = {
      first: "Procedure Templates"
    };
    dispatch(Change(data));
  }, [show]);

  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox
            value={searchValue}
            onChange={(event) => onChangeSearch(event)}
          />
        </Col>
        <Col md={7} className="d-flex justify-content-end">
          <DashTabs
            setShow={setShow}
            show={show}
            setUpdateData={setUpdateData}
            setView={setView}
          />
        </Col>
      </Row>

      <div className="row">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            setShow={setShow}
            procedureData={procedureData}
            setUpdateData={setUpdateData}
            setView={setView}
            refetch={refetch}
          />
        </div>
        {show && (
          <div
            className="col-4 "
            style={{ backgroundColor: "white" }}
          >
            <AddProcedure
              refetch={refetch}
              updateData={updateData}
              view={view}
              setShow={setShow}
            />
          </div>
        )}
        <Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={procedureData}
        />
      </div>
    </div>
  );
};

export default ProcedureTemplates;
